module.exports = "<div class=\"alert alert-danger\" role=\"alert\">\n  <h1 ng-bind=\"'NOTFOUND' | translate\"></h1>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/errors/notfound/notfound.html
 ** module id = 359
 ** module chunks = 0
 **/